export interface PollsAccessContext {
  pollsEnabled: boolean;
  canManagePolls: boolean;
  canTakePolls: boolean;
  isBreakoutRoom: boolean;
  isSystemSession: boolean;
}

export const canAccessPolls = (ctx: PollsAccessContext): boolean =>
  !ctx.isBreakoutRoom &&
  ctx.pollsEnabled &&
  (ctx.canManagePolls || ctx.canTakePolls || ctx.isSystemSession);
